import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@workos-inc/authkit-react";
import { Box, CircularProgress } from "@mui/material";

interface RequireRoleProps {
  roleSlug: string;
  children: React.ReactNode;
}

export function RequireRole({
  roleSlug,
  children,
}: RequireRoleProps) {
  const { isLoading, role } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // WorkOS nested role object usually has { slug, name }
  if (role !== roleSlug) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
